module.exports = __webpack_public_path__ + "img/freehand_logo.bbf3db13.png";